import React from 'react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import SelectBlock from '../../../../components/SelectBlock';
import constants from '../../../../../constants/constants';

const jobSections = [
  { key: 'general-information', label: 'General Information' },
  { key: 'team', label: 'Credential & Team' },
  { key: 'schedule', label: 'Schedule' },
  { key: 'forms', label: 'Forms' },
  { key: 'timesheet', label: 'Timesheet' },
  { key: 'documents', label: 'Documents' },
];

const getAwardedDateTime = (jobInfo) => {
  const awardedDateTime = (jobInfo.awardedDateTime || '').trim();
  const timeMatch = awardedDateTime.match(/\b\d{1,2}:\d{2}(?::\d{2})?(?:\s*[AP]M)?\b/i);

  return {
    date: jobInfo.awardedDate || (timeMatch ? awardedDateTime.slice(0, timeMatch.index).replace(/[T,\s]+$/, '') : awardedDateTime),
    time: jobInfo.awardedTime || (timeMatch ? timeMatch[0] : ''),
  };
};

const JobMobileNavigation = ({ jobId, jobInfo, auth }) => {
  const history = useHistory();
  const location = useLocation();
  const currentSection = jobSections.find((section) => location.pathname.includes(`/manage-job/${section.key}/`)) || jobSections[0];
  const sectionOptions = jobSections.map((section) => ({
    value: section.key,
    label: section.label,
  }));
  const selectedSection = sectionOptions.find((option) => option.value === currentSection.key);
  const awarded = getAwardedDateTime(jobInfo);

  const navigateToSection = (selectedOption) => {
    if (selectedOption) {
      history.push(`/services/manage-job/${selectedOption.value}/${jobId}`);
    }
  };

  return (
    <section className='aes-job-mobile-navigation d-lg-none' aria-labelledby='aes-job-mobile-navigation-title'>
      <div className='aes-job-mobile-navigation__summary'>
        <div>
          <span className='aes-job-mobile-navigation__eyebrow'>Job Profile</span>
          <h2 id='aes-job-mobile-navigation-title' className='font-size-h2 font-weight-boldest'>
            Job #{jobInfo.projectNumber}
          </h2>
        </div>
        {jobInfo.projectName && <p className='aes-job-mobile-navigation__project-name'>{jobInfo.projectName}</p>}
      </div>

      <div className='aes-job-mobile-navigation__context'>
        {(awarded.date || awarded.time) && (
          <div className='aes-job-mobile-navigation__details'>
            {awarded.date && (
              <div className='aes-job-mobile-navigation__detail'>
                <span>Awarded date</span>
                <strong>{awarded.date}</strong>
              </div>
            )}
            {awarded.time && (
              <div className='aes-job-mobile-navigation__detail'>
                <span>Awarded time</span>
                <strong>{awarded.time}</strong>
              </div>
            )}
          </div>
        )}

        {jobInfo.proposalId && (
          <div className='aes-job-mobile-navigation__actions'>
            <Link
              to={`/services/manage-proposal/general-information/${jobInfo.proposalId}`}
              className='btn btn-sm btn-success font-weight-bold'
            >
              View Proposal
            </Link>
            {auth && auth.authToken && (
              <a
                className='btn btn-sm btn-info font-weight-bold'
                href={`${constants.API_URL}api/Proposal/GetProposalPdf?proposalId=${jobInfo.proposalId}&token=${auth.authToken}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                View Proposal PDF
              </a>
            )}
          </div>
        )}
      </div>

      <SelectBlock
        label='Current section'
        className='aes-job-mobile-navigation__select'
        selectClassNamePrefix='aes-job-navigation-select'
        containerClassName='aes-job-mobile-navigation__select-container'
        options={sectionOptions}
        value={selectedSection}
        onChange={navigateToSection}
        isSearchable={false}
        menuPortalTarget={document.body}
        menuPosition='fixed'
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 1060 }),
        }}
      />
    </section>
  );
};

export default JobMobileNavigation;
